import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import constants from '../../../../presentation/modules/procedures/constants';
import config from '../../../../core/config/config';
import XCheckpointManager from '@/core/managers/xcheckpointManager';
import { listProcedures } from './procedure-list';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.GET_STUDENT_PROCEDURE_STATUS_REQUEST });
    const procedure: any = listProcedures.find(
      (item: any) => item.procedureId === action.procedureId
    );
    if (procedure)
      XCheckpointManager.registerStart(`${procedure?.name} - progress`);
    const procedureRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureResponse = yield call(
      procedureRepository.getProcedureRequestDetail,
      action.procedureId,
      action.requestId
    );

    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    if (!procedureResponse) {
      yield put({
        type: Types.GET_STUDENT_PROCEDURE_STATUS_FAILURE,
        error: 'No se pudo leer los datos del trámite.'
      });
      return;
    }

    let statusList;
    if (
      constants.categories.requests.procedures.updatePhoto ===
      action.procedureId
    ) {
      statusList = constants.procedureStatus.updatePhoto;
    } else if (
      constants.categories.requests.procedures.removeOfPeriod ===
      action.procedureId
    ) {
      statusList = constants.procedureStatus.removeFromPeriod;
    } else if (
      constants.categories.requests.procedures.changeCareerCampusModality ===
      action.procedureId
    ) {
      statusList = constants.procedureStatus.changeCareerCampusModality;
    } else if (
      constants.categories.requests.procedures.issuanceUniversityCard ===
      action.procedureId
    ) {
      statusList = constants.procedureStatus.issuanceCarnetCard;
    } else if (
      constants.categories.certificates.type1List.find(
        (p) => p.procedureId === action.procedureId
      )
    ) {
      statusList = constants.procedureStatus.certificatesType01;
    }
    const status = statusList?.find(
      (p) => p.name === procedureResponse?.request?.status?.status
    );

    yield put({
      type: Types.GET_STUDENT_PROCEDURE_STATUS_SUCCESS,
      data: procedureResponse,
      isComplete: status?.isComplete,
      isApproved: status?.isApproved
    });
    if (procedure)
      XCheckpointManager.registerEnd(`${procedure?.name} - progress`);
  } catch (error) {
    yield put({
      type: Types.GET_STUDENT_PROCEDURE_STATUS_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos del trámite solicitado.'
    });
  }
}
